import React from "react";
import { styled } from "@linaria/react";
import t from "../../../../../i18n";
import { color, fonts } from "@ui";
import ErrorWarningFill from "@ui/IconV2/react/ErrorWarningFill";
import AdditionnalMessage from "@ui/AdditionnalMessage";

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  font: ${fonts.h4};
`;

export const CardAction = styled.div`
  & a {
    padding: 0 8px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  font: ${fonts.body1};
`;

export const CardInfoLine = styled.div`
  margin-bottom: 8px;
`;

export const WarningText = styled.div`
  margin-top: 10px;
  color: ${color.error};

  > :first-child {
    transform: translateY(0.2em);
    margin-right: 0.2em;
  }
`;

export const StyledWarning = styled(ErrorWarningFill)`
  margin-right: 5px;
`;

export const Subtitle = styled.div`
  color: ${color.carbon900};
  font: ${fonts.body1SemiBold};
`;

export const WarningComponent = ({
  impactedAnalysisCount: impactedCount,
}: {
  impactedAnalysisCount: number;
}) => (
  <>
    {impactedCount > 0 && (
      <div style={{ font: fonts.body2 }}>
        <AdditionnalMessage
          status="WARNING"
          text={t("setup.paragraphs.model.modal.delete_model.warningText", {
            impactedAnalysisCount: impactedCount,
          })}
        />
      </div>
    )}
  </>
);
